import axios from 'axios';

const api = axios.create({
  baseURL: 'https://scvc-backend.onrender.com/', // CHANGE THIS
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
